import { Suspense } from 'react';
import AgentPageClient from '../agent/AgentPageClient';

function AgentPageLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center p-3 sm:p-4 md:p-6"></div>
  );
}

export default function AgentPage() {
  return (
    <Suspense fallback={<AgentPageLoading />}>
      <AgentPageClient />
    </Suspense>
  );
}
